import React from "react";

const LoadingSpinal = () => {
  return <div className="loader"></div>;
};

export default LoadingSpinal;
